angular.module('SpidApp')

.factory('OrderService', ['Restangular', '_', 'Agency', '$localStorage', 'VacationService', '$state', 'Transaction', 'ConfigService', 'OrderItemDbAdapter',
function (Restangular, _, Agency, $localStorage, VacationService, $state, Transaction, ConfigService, OrderItemDbAdapter) {
        var OrderService = {

            all: function () {
                return Restangular.all('orders').getList().then()
            },

            getByAgencyId: function (agencyId) {
                if (agencyId === null || agencyId === undefined) {
                    throw 'Order::getByAgencyId() - Missing parameters'
                }

                return Restangular.one('agencies', agencyId).all('orders').all('orderStatus').getList().then()
            },

            getById: function (agencyId, id, lot) {
                if (agencyId === null || agencyId === undefined || id === null || id === undefined || lot === null || lot === undefined) {

                    throw 'Order::getById() - Missing parameters'
                }

                return Restangular.one('agencies', agencyId).one('orders', id).one('lot', lot).all('orderItems').all('orderStatus').getList().then(function (data) {
                    return _.chain(data).groupBy(function (obj) {
                        return obj.orders_id;
                    }).map(function (group) {

                        var oStatus = _.chain(group).sortBy('status_updated_at', function (obj) {
                            return moment(obj.status_updated_at, moment.ISO_8601).fromNow();
                        });

                        var aStatus = oStatus.value();

                        var lastIndexStatus = oStatus.findLastIndex().value();
                        var lastStatus = aStatus[lastIndexStatus];

                        var oItem = _.chain(group).groupBy(function (item) {
                            return item.obj_table_ref + '#' + item.obj_id
                        }).map(function (aItem) {

                            var oItem = _.chain(aItem).sortBy('item_updated_at', function (obj) {
                                return moment(obj.status_updated_at, moment.ISO_8601).fromNow();
                            });

                            var lastIndexItem = oItem.findLastIndex().value();
                            var aItemTmp = oItem.value();
                            return aItemTmp[lastIndexItem];
                        });

                        return {
                            orders_id: group[0].orders_id,
                            lot: group[0].lot,
                            items: oItem.value(),
                            lastStatus: lastStatus,
                            firstStatus: aStatus[0],
                            aStatus: _.uniq(aStatus, function (status) {
                                return status.status_updated_at
                            })
                        }
                    }).value()
                })
            },

            save: function (order) {

                if (!order) {
                    throw 'OrderService::save() - Missing parameters'
                }

                var configServiceMemo = null;
                return ConfigService.all().then(function (memo) {
                    configServiceMemo = memo;
                }).then(function () {
                    var aOrderItem = [];
                    var method = "POST";
                    var path = "/orders"

                    var payload = {
                        id: order.order_id,
                        status: order.status,
                        agency_id: configServiceMemo.agencyId,
                        lot: order.lot
                    }

                    var call = {
                        'method': method,
                        'path': path,
                        'payload': payload
                    };

                    aOrderItem.push(call);

                    for (var key in order.objects) {
                        if(order.objects.hasOwnProperty(key)) {
                            method = "POST";
                            var relative_url = "/orders/$0.id/lot/$0.lot/orderItem"

                            var body = OrderItemDbAdapter.fromModelToDb(order.objects[key]);
                            body.agency_id = configServiceMemo.agencyId;
                            body.obj_id = order.objects[key].id;

                            call = {
                                'method': method,
                                'path': relative_url,
                                'payload': body
                            };

                            aOrderItem.push(call);
                        }
                    }

                    if (order.status) {
                        path = "/ordersStatus/$0.id/lot/$0.lot";

                        payload = {
                            order_id: order.order_id,
                            status: order.status,
                            agency_id: configServiceMemo.agencyId,
                            user: order.user
                        };

                        call = {
                            'method': method,
                            'path': path,
                            'payload': payload
                        };

                        aOrderItem.push(call);
                    }

                    var batch = Restangular.one("batch");
                    var params = {};
                    params.requests = aOrderItem;

                    return batch.customPOST(params).then(function (data) {
                        var j = 0;
                        if (order.order_id === 0 && data && data[0] && data[0].id) {
                            order.order_id = data[0].id;
                            order.lot = data[0].lot;
                            j++;
                        }

                        for (var i = 0; i < order.objects.length - 1; i++) {
                            if (order.objects && order.objects[i] && data && data[j] && data[j].id) {
                                order.objects[i].key = data[j].id;
                                j++;
                            }
                        }

                        return order;
                    });
                })
            }
        }

        return OrderService
}])